// Third-party libraries, bundled from npm instead of loaded from CDNs.
import * as Leaflet from "leaflet";

export const L = { ...Leaflet };
if (typeof window !== "undefined") window.L ??= L;
